import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { BOOLEAN_TYPES, DEFAULT_PAGE } from '../constants'

const TaskHasScrapingIssueCommentFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { hasScrapingIssueComment } = getQueryParams(search)

  const handleChange = useCallback(
    hasScrapingIssueComment =>
      history.push(
        createUrl(pathname, search, {
          hasScrapingIssueComment,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Scraping issue">
      <Select
        style={{ width: '100%' }}
        value={hasScrapingIssueComment?.toString()}
        onChange={handleChange}
        allowClear
      >
        {map(BOOLEAN_TYPES, ({ name, value }) => (
          <Select.Option key={value} value={value?.toString()}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default TaskHasScrapingIssueCommentFilter
